 /* eslint-disable import/no-unresolved */
  /* eslint-disable jsx-a11y/control-has-associated-label */ 
  import { useEffect, useState } from 'react'; 
  import { useQuery, useLazyQuery, useMutation, useReactiveVar, } from '@apollo/client'; import { getUserInfoVar, leftNavigationItemsVar, showCrossReportConfigVar, showDataReconMenusVar, showReportMenuVar, currentLeftMenuVar, moduleIdVar, } from 'Apollo/config';
  import { useHistory, useLocation } from 'react-router-dom';
import {
EDIT_USER, IAM_CHANGE_USER_ACCESS_STATUS, IAM_CHANGE_USER_ROLE, IAM_UPDATE_USER,
ADD_USER_TO_PRODUCT,
} from 'Apollo/Mutations';
import {
GET_USER_BY_ID, GET_USER_INFO, GET_USER_ROLES, GET_USER_TENANT_ROLES,
GET_TENANTS,
GET_MODULES,
} from 'Apollo/Queries';
import { ModuleEnum } from 'constants';
import { listItems } from './utils';
import CreateOrEditUser from '../components/CreateOrEditUser';

// product name
const productName = process.env.REACT_APP_PRODUCT;

// User roles in TCR
const roles = [
{ id: 1, value: 'Member', name: 'MEMBER' },
{ id: 2, value: 'Admin', name: 'ADMIN' },
];

// send ADMIN/MEMBER
const toIamRoleEnum = role => {
    if (!role) return 'MEMBER';
    const upper = role.toUpperCase();
    if (upper === 'ADMIN') return 'ADMIN';
    return 'MEMBER';
};

const CreateOrEditUserContainer = () => {
const history = useHistory();
const location = useLocation();
const loggedInUser = useReactiveVar(getUserInfoVar);
const [userId, setUserId] = useState(location.state.userId);
const [tenant, setTenant] = useState('');
const [tenantName, setTenantName] = useState('');
const [userRole, setUserRole] = useState('');
const [firstName, setFirstName] = useState('');
const [lastName, setLastName] = useState('');
const [email, setEmail] = useState('');
const [jobTitle, setJobTitle] = useState('');
const [jobDepartment, setJobDepartment] = useState('');
const [organizationId, setOrgnizationId] = useState('');
const [userStatus, setUserStatus] = useState('');
const [iamUserRole, setIAMUserRole] = useState('MEMBER');
const [grantAdminRights, setGrantAdminRights] = useState(false);
const [emailError, setEmailError] = useState(false);
const [firstNameError, setFirstNameError] = useState(false);
const [lastNameError, setLastNameError] = useState(false);
const [showErrorAlert, setShowErrorAlert] = useState(false);
const [errorMsg, setErrorMsg] = useState('');
const [showSuccessAlert, setShowSuccessAlert] = useState(false);
const [successMsg, setSuccessMsg] = useState('');
const [userData, setUserData] = useState(null);
const [showWarningMessage, setShowWarningMessage] = useState(false);
const [warnMsg, setWarnMsg] = useState(null);
const [isSelfLoggedIn, setIsSelfLoggedIn] = useState(false);
const [defaultTenant, setDefaultTenant] = useState(null);
const [userMappedTenants, setUserMappedTenants] = useState([]);
const [showAddTenantPanel, setShowAddTenantPanel] = useState(false);
const [showEditTenantPanel, setShowEditTenantPanel] = useState(false);
const [editTenant, setEditTenant] = useState(null);
const [updateUserTenantList, setUpdateUserTenantList] = useState([]);
const [showConfirmDelete, setShowConfirmDelete] = useState(false);
const [confirmReset, setConfirmReset] = useState(false);
const [deleteTenant, setDeleteTenant] = useState(null);
const [deletedUserTenantIds, setDeletedUserTenantIds] = useState([]);
const [pageTitle, setPageTitle] = useState('Create User');
const [selectedModuleIds, setSelectedModuleIds] = useState([]);
const [moduleOptions, setModuleOptions] = useState([]);

/* Apollo query to fetch logged user info */
const { data = {} } = useQuery(GET_USER_INFO);

const userRoles = useQuery(GET_USER_ROLES);
const { data: modules } = useQuery(GET_MODULES);

// Transform getModules API data into react-select options
useEffect(() => {
    const moduleData = modules?.getModules?.map(mod => ({
        value: mod.moduleId,
        label: mod.moduleDisplayName,
    })) || [];
    setModuleOptions(moduleData);
}, [modules]);

/* Apollo query to fetch user details by user_id */
const [getUserById, {
    data: getUserData, refetch,
}] = useLazyQuery(GET_USER_BY_ID, {
    fetchPolicy: 'no-cache',
});

/* Apollo mutation for addUserToProduct */
const [addUserToProduct, { loading: addUserToProductLoading }] = useMutation(ADD_USER_TO_PRODUCT);

/* Apollo mutation to edit user in RDRR */
const [editUser, { loading: editUserLoading }] = useMutation(EDIT_USER);

/* Apollo mutation to edit user in IAM */
const [updateUser, { loading: updateUserLoading }] = useMutation(IAM_UPDATE_USER, {
    variables: {
        input: {
            email,
            firstName,
            lastName,
            organizationId: userData?.organizationIdList?.[0] || organizationId,
            product: productName,
        },
    },
});

/* Apollo mutation to change user role */
const [changeUserRole, { loading: changeRoleLoading }] = useMutation(IAM_CHANGE_USER_ROLE, {
    variables: {
        input: {
            email,
            organizationId: userData?.organizationIdList?.[0] || organizationId,
            role: toIamRoleEnum(iamUserRole),
            requestingUserEmail: data?.getUser?.email,
            product: productName,
        },
    },
});

/* Apollo mutation to change user access status */
const [changeUserAccessStatus, { loading: changeStatusLoading }] = useMutation(IAM_CHANGE_USER_ACCESS_STATUS, {
    variables: {
        input: {
            email,
            organizationId: userData?.organizationIdList?.[0] || organizationId,
            accessStatus: userStatus,
            requestingUserEmail: data?.getUser?.email,
            product: productName,
        },
    },
});

const [getUserTenantRoles, { data: userTenantRoles }] = useLazyQuery(GET_USER_TENANT_ROLES, {
    fetchPolicy: 'no-cache',
});

const { data: tenants } = useQuery(GET_TENANTS);

/** Keep grantAdminRights in sync with iamUserRole */
useEffect(() => {
    setGrantAdminRights(iamUserRole === 'ADMIN');
}, [iamUserRole]);

/** Calls changeUserAccessStatus() and editUser() */
const changeStatus = async () => {
    if (Object.keys(data).length > 0 && userStatus && (userStatus !== (userData?.iamUserStatus))) {
        changeUserAccessStatus().then(async _updateAccessRes => {
            if (_updateAccessRes.data.IAMchangeUserAccessStatus.status === 'SUCCESS') {
                try {
                    const editUserResponse = await editUser({
                        variables: {
                            input: {
                                firstName: userData?.firstName,
                                lastName: userData?.lastName,
                                userId: parseInt(userId, 10),
                                iamUserStatus: userStatus,
                                iamRole: iamUserRole,
                                userStatus,
                            },
                        },
                    });
                    if (!editUserResponse.data.editUser) {
                        setErrorMsg('Error while updating User in Report Inspector!');
                        setShowErrorAlert(true);
                    }
                    setSuccessMsg('User Status Updated Successfully!');
                    setShowSuccessAlert(true);
                    refetch();
                } catch (err) {
                    setErrorMsg('Error while updating User Status!');
                    setShowErrorAlert(true);
                }
            }
        }).catch(_updateAccessErr => {
            setErrorMsg(_updateAccessErr.message);
            setShowErrorAlert(true);
        });
    }
};

/** Save action */
const onSave = async () => {
    let _updateRoleRes;
    let _updateUserRes;
    const isValidEmail = (email !== '' && emailError === false);
    const isValidFirstName = (firstName !== '' && firstNameError === false);
    const isValidLastName = (lastName !== '' && lastNameError === false);
    const isValidName = isValidFirstName && isValidLastName;

    const formPayload = {
        firstName,
        lastName,
        email,
        iamUserRole,
        grantAdminRights,
        userStatus,
        moduleIds: selectedModuleIds,
        userTenants: updateUserTenantList,
        deletedUserTenantIds,
    };

    if (isValidEmail && isValidName) {
        setShowErrorAlert(false);
        setShowSuccessAlert(false);
       if (!userData) {
    // CREATE flow: single API call using addUserToProduct
    try {
        const resolvedOrgId = loggedInUser?.getUser?.organizationIdList?.[0] || organizationId;
        const resolvedTenantId = defaultTenant?.tenantId || loggedInUser?.getUser?.iamTenant?.tenantId;
        const iamTenantData = loggedInUser?.getUser?.iamTenant;

        if (!resolvedOrgId) {
            setErrorMsg('Organization ID is not available. Please contact admin.');
            setShowErrorAlert(true);
            return;
        }

        if (!resolvedTenantId) {
            setErrorMsg('Tenant ID is not available. Please contact admin.');
            setShowErrorAlert(true);
            return;
        }

        //ADMIN/MEMBER
        const iamRoleEnumValue = iamUserRole.toUpperCase() === 'ADMIN' ? 'ADMIN' : 'MEMBER';

        // ✅ Resolve the correct group ID based on admin rights checkbox
        const resolvedGroupId = grantAdminRights
            ? iamTenantData?.orgAdminGroupId
            : iamTenantData?.orgUserGroupId;


        // Build payload — now includes groupId
        const addUserPayload = {
            userEmail: email,
            requestingUserEmail: data?.getUser?.email,
            organizationId: resolvedGroupId,
            firstName,
            lastName,
            iamRole: iamRoleEnumValue,
            iamTenantId: resolvedTenantId,
            isCreateUser: true,
            moduleIds: selectedModuleIds,
            userTenants: updateUserTenantList,
        };

        const addUserResponse = await addUserToProduct({
            variables: {
                input: addUserPayload,
            },
        });

        const { status, description } = addUserResponse.data.addUserToProduct;

        if (status === 'SUCCESS') {
            history.push('/user-management');
        } else {
            setErrorMsg(description || `Failed to add user. Status: ${status}`);
            setShowErrorAlert(true);
        }
    } catch (addUserError) {
        setErrorMsg(addUserError.message || 'An error occurred while adding user to product.');
        setShowErrorAlert(true);
    }
} else {
            // EDIT flow
            // 1 - iam_role change
            if (!isSelfLoggedIn && iamUserRole !== (userData?.iamRole)) {
                try {
                    _updateRoleRes = await changeUserRole();
                } catch (_updateRoleErr) {
                    setErrorMsg('User IAM Role update is failed because of requesting  user is not an admin or requesting user is not allowed to perform operations on self.');
                    setShowErrorAlert(true);
                    setIAMUserRole(userData.iamRole);
                }
            }
            // 2 - updateUser
            if (firstName !== (userData?.firstName) || lastName !== (userData?.lastName)) {
                try {
                    _updateUserRes = await updateUser();
                } catch (_updateUserErr) {
                    setErrorMsg('User update failed because of User has not registered for the organization or User not found.');
                    setShowErrorAlert(true);
                    setFirstName(userData.firstName);
                    setLastName(userData.lastName);
                }
            }
            const isValidUpdateRoleRes = (_updateRoleRes?.data?.IAMchangeUserRole.status === 'SUCCESS');
            const isValidUpdateUserRes = (_updateUserRes?.data?.IAMupdateUser.status === 'SUCCESS');
            const isValidIAMUpdateRes = isValidUpdateRoleRes || isValidUpdateUserRes;
            if ((errorMsg === '') || (isValidIAMUpdateRes)) {
                try {
                    const editPayload = {
                        firstName,
                        lastName,
                        userStatus,
                        deletedUserTenantIds,
                        userTenants: updateUserTenantList,
                        userId: parseInt(userId, 10),
                        iamUserStatus: userStatus,
                        iamRole: iamUserRole,
                        moduleIds: selectedModuleIds,
                    };

                    const editUserResponse = await editUser({
                        variables: {
                            input: editPayload,
                        },
                    });
                    if (!editUserResponse.data.editUser) {
                        setErrorMsg('Error while updating User in Report Inspector!');
                        setShowErrorAlert(true);
                    }
                    history.push('/user-management');
                } catch (err) {
                    setErrorMsg('Error while updating User in Report Inspector!');
                    setShowErrorAlert(true);
                }
            }
        }
    } else {
        console.log('Form payload at time of failure:', JSON.stringify(formPayload, null, 2));
    }
};

/* Breadcrumb items configuration */
const breadcrumbItems = [
    {
        link: '',
        value: (
            <span
                className="appkiticon icon-home-fill font-16"
                onClick={
                    () => {
                        showReportMenuVar(false);
                        history.push('/');
                        showCrossReportConfigVar(false);
                        leftNavigationItemsVar([]);
                        moduleIdVar(null);
                    }
                }
                role="presentation"
            />
        ),
    },
    {
        link: '',
        value: <span className="a-breadcrumb-item-text" onClick={() => history.goBack()} role="presentation">User Management</span>,
    },
    {
        link: '',
        value: <span className="a-breadcrumb-item-text">{location?.state?.userId ? 'Edit user' : 'Create User'}</span>,
    },
];

const assignTenantChange = () => {
    setEditTenant(null);
    setShowAddTenantPanel(true);
    setTenant('');
    setTenantName('');
    setUserRole('');
    setJobTitle('');
    setJobDepartment('');
};

const onEdit = editTenantObj => {
    setShowEditTenantPanel(true);
    setEditTenant(editTenantObj);
    setTenant(editTenantObj.tenantId);
    setTenantName(editTenantObj.tenant.name);
    setUserRole(editTenantObj.userRoleId);
    setJobTitle(editTenantObj.jobTitle ? editTenantObj.jobTitle : '');
    setJobDepartment(editTenantObj.department ? editTenantObj.department : '');
};

const onUpdateTenant = () => {
    const updateTenantList = userMappedTenants.map(ut => {
        if (ut.tenantId === editTenant.tenantId) {
            const newUserRole = userRoles.data && userRoles.data.getUserRoles.filter(ur => ur.userRoleId === userRole)[0];
            return {
                ...ut,
                jobTitle,
                department: jobDepartment,
                userRoleId: userRole,
                userRole: newUserRole,
            };
        }
        return ut;
    });
    const updatedTenantObj = userMappedTenants.map(ut => {
        if (ut.tenantId === editTenant.tenantId) {
            return {
                jobTitle,
                department: jobDepartment,
                userRoleId: userRole,
                userId: ut.userId,
                tenantId: ut.tenantId,
                userTenantRoleId: ut.userTenantRoleId,
            };
        }
        return {
            jobTitle: ut.jobTitle,
            department: ut.jobDepartment,
            userRoleId: ut.userRoleId,
            userId: ut.userId,
            tenantId: ut.tenantId,
            userTenantRoleId: ut.userTenantRoleId,
        };
    });
    setUserMappedTenants(updateTenantList);
    setShowEditTenantPanel(false);
    setEditTenant(null);
    setUpdateUserTenantList(updatedTenantObj);
};

const onAssignTenant = () => {
    const newUserRole = userRoles.data && userRoles.data.getUserRoles.filter(ur => ur.userRoleId === userRole)[0];
    const newTenant = tenants && tenants.getTenants.filter(t => t.tenantId === tenant)[0];
    const newTenantObj = {
        jobTitle,
        department: jobDepartment,
        userRoleId: userRole,
        userRole: newUserRole,
        userId: userData?.userId,
        tenantId: tenant,
        tenant: newTenant,
    };
    setUserMappedTenants(prevState => {
        const prevData = [...prevState];
        return prevData.concat(newTenantObj);
    });
    setUpdateUserTenantList(prevState => {
        const prevData = [...prevState];
        return prevData.concat({
            jobTitle,
            department: jobDepartment,
            userRoleId: userRole,
            userId: userData?.userId,
            tenantId: tenant,
        });
    });
    setShowAddTenantPanel(false);
};

const onDelete = deleteTenantObj => {
    setShowConfirmDelete(true);
    setDeleteTenant(deleteTenantObj);
};

const validateEmail = emailId => {
    setErrorMsg('');
    setShowErrorAlert(false);
    const pattern = /^[a-zA-Z0-9+_._]+@[a-zA-Z0-9.]+$/;
    if (!pattern.test(emailId)) {
        setEmailError(true);
    } else if (!emailId.endsWith('@pwc.com') && !emailId.endsWith('@us.pwc.com')) {
        setEmailError(true);
        setErrorMsg('Only @pwc.com and @us.pwc.com domains are allowed!');
        setShowErrorAlert(true);
    } else {
        setEmailError(false);
    }
};

const validateFirstName = fName => {
    setErrorMsg('');
    setShowErrorAlert(false);
    if (fName.trim() === '') {
        setFirstNameError(true);
    } else {
        setFirstName(fName);
        setFirstNameError(false);
    }
};

const validateLastName = lName => {
    setErrorMsg('');
    setShowErrorAlert(false);
    if (lName.trim() === '') {
        setLastNameError(true);
    } else {
        setLastName(lName);
        setLastNameError(false);
    }
};

useEffect(() => {
    leftNavigationItemsVar(listItems);
    showCrossReportConfigVar(false);
    showDataReconMenusVar(false);
    showReportMenuVar(false);
    currentLeftMenuVar(ModuleEnum.USER);
}, []);

/* Side effect when location updates */
useEffect(() => {
    setUserId(location?.state?.userId);
    if (location?.state?.userId) {
        setPageTitle('Edit User');
    } else {
        setPageTitle('Create User');
    }
}, [location]);

useEffect(() => {
    if (userId) {
        getUserById({
            variables: {
                input: {
                    userId: parseInt(userId, 10),
                },
            },
        });
        getUserTenantRoles({
            variables: {
                input: {
                    userId: parseInt(userId, 10),
                },
            },
        });
    }
}, [userId]);

/* Side effect when getUserData updates */
useEffect(() => {
    if (getUserData && Object.keys(getUserData?.getUserById).length > 0) {
        setUserData(getUserData?.getUserById);

        // Pre-populate selected modules from API
        if (getUserData?.getUserById?.moduleIds) {
            setSelectedModuleIds(getUserData.getUserById.moduleIds);
        }
    }
}, [getUserData]);

/* Side effect when userId and userData updates */
useEffect(() => {
    if (userId && userData) {
        setUserStatus(userData.iamUserStatus);
        setIAMUserRole(userData.iamRole);
        setGrantAdminRights(
            userData.iamRole === 'ADMIN'
            || userData.iamRole === 'Admin',
        );
        setFirstName(userData.firstName);
        setLastName(userData.lastName ? userData.lastName : '');
        setEmail(userData.email ? userData.email : '');
    }
}, [userId, userData]);

/* Side effect when loggedInUser updates */
useEffect(() => {
    if (loggedInUser?.getUser?.iamTenant) {
        setTenant(loggedInUser.getUser.iamTenant.tenantId);
        const orgId = loggedInUser.getUser.organizationIdList?.[0] || '';
        setOrgnizationId(orgId);
    }
}, [loggedInUser]);

/* Side effect when loggedInUser and userId updates */
useEffect(() => {
    if (loggedInUser && userId && loggedInUser.getUser && userId === loggedInUser.getUser.userId) {
        setIsSelfLoggedIn(true);
    }
}, [loggedInUser, userId]);

/* Side effect when userStatus or data updates */
useEffect(() => {
    if (isSelfLoggedIn && userStatus === 'DISABLED') {
        setShowWarningMessage(true);
        setWarnMsg('Requesting user is not allowed to update status of self.');
        setUserStatus(userData?.iamUserStatus);
    } else {
        changeStatus();
    }
}, [userStatus, data]);

useEffect(() => {
    if (userData && userTenantRoles && userTenantRoles.getUserTenantRoles) {
        const iamTenant = userTenantRoles.getUserTenantRoles.filter(ur => ur.tenantId === userData.iamTenant.tenantId)[0];
        setDefaultTenant(iamTenant);
        setUserMappedTenants(userTenantRoles.getUserTenantRoles);
        setUpdateUserTenantList(userTenantRoles.getUserTenantRoles.map(utr => ({
            jobTitle: utr.jobTitle,
            department: utr.jobDepartment,
            userRoleId: utr.userRoleId,
            userId: utr.userId,
            tenantId: utr.tenantId,
            userTenantRoleId: utr.userTenantRoleId,
        })));
    }
}, [userData, userTenantRoles]);

useEffect(() => {
    setEditTenant(null);
    if (confirmReset) {
        setUserMappedTenants(prevState => {
            const prevData = [...prevState];
            const updatedPrevData = prevData.filter(ut => ut.tenant.name !== deleteTenant.tenant.name);
            return updatedPrevData;
        });
    }
    setConfirmReset(false);
}, [confirmReset]);

useEffect(() => {
    if (deleteTenant?.userTenantRoleId) {
        setDeletedUserTenantIds(prevState => {
            let prevData = [...prevState];
            prevData = prevData.concat(deleteTenant?.userTenantRoleId);
            return prevData;
        });
    }
}, [deleteTenant]);

useEffect(() => {
    if (!location?.state?.userId && location?.state?.createUser && tenants?.getTenants.length > 0) {
        const iamTenant = tenants.getTenants.filter(t => t.tenantId === loggedInUser?.getUser?.iamTenant?.tenantId)[0];
        setDefaultTenant(iamTenant);
        const tenantObj = tenants.getTenants.filter(t => t.tenantId === loggedInUser?.getUser?.iamTenant?.tenantId)[0];
        if (tenantObj && Object.keys(tenantObj).length) {
            const newTenant = {
                tenant: tenantObj,
                tenantId: tenantObj?.tenantId,
                jobTitle,
                department: jobDepartment,
            };
            setUserMappedTenants(prevState => {
                const prevData = [...prevState];
                return prevData.concat(newTenant);
            });
            setUpdateUserTenantList(prevState => {
                const prevData = [...prevState];
                return prevData.concat({
                    jobTitle,
                    department: jobDepartment,
                    tenantId: tenantObj?.tenantId,
                });
            });
        }
    }
}, [location, loggedInUser, tenants]);

return (
    <CreateOrEditUser
        history={history}
        breadcrumbItems={breadcrumbItems}
        tenantName={tenantName}
        userRoles={userRoles.data && userRoles.data.getUserRoles}
        roles={roles}
        userData={userData}
        addUserToProductLoading={addUserToProductLoading}
        changeStatusLoading={changeStatusLoading}
        editUserLoading={editUserLoading}
        updateUserLoading={updateUserLoading}
        changeRoleLoading={changeRoleLoading}
        validateEmail={validateEmail}
        validateFirstName={validateFirstName}
        validateLastName={validateLastName}
        onSave={onSave}
        showErrorAlert={showErrorAlert}
        setShowErrorAlert={setShowErrorAlert}
        errorMsg={errorMsg}
        setTenant={setTenant}
        tenant={tenant}
        userStatus={userStatus}
        setUserStatus={setUserStatus}
        setUserRole={setUserRole}
        userRole={userRole}
        firstName={firstName}
        setFirstName={setFirstName}
        firstNameError={firstNameError}
        setIAMUserRole={setIAMUserRole}
        iamUserRole={iamUserRole}
        grantAdminRights={grantAdminRights}
        setGrantAdminRights={setGrantAdminRights}
        email={email}
        setEmail={setEmail}
        emailError={emailError}
        lastName={lastName}
        setLastName={setLastName}
        lastNameError={lastNameError}
        jobTitle={jobTitle}
        setJobTitle={setJobTitle}
        jobDepartment={jobDepartment}
        setJobDepartment={setJobDepartment}
        successMsg={successMsg}
        showSuccessAlert={showSuccessAlert}
        setShowSuccessAlert={setShowSuccessAlert}
        showWarningMessage={showWarningMessage}
        warnMsg={warnMsg}
        setShowWarningMessage={setShowWarningMessage}
        isSelfLoggedIn={isSelfLoggedIn}
        defaultTenant={defaultTenant}
        userMappedTenants={userMappedTenants}
        assignTenantChange={assignTenantChange}
        showAddTenantPanel={showAddTenantPanel}
        tenants={tenants}
        onEdit={onEdit}
        editTenant={editTenant}
        showEditTenantPanel={showEditTenantPanel}
        setShowEditTenantPanel={setShowEditTenantPanel}
        onUpdateTenant={onUpdateTenant}
        onAssignTenant={onAssignTenant}
        setShowAddTenantPanel={setShowAddTenantPanel}
        onDelete={onDelete}
        showConfirmDelete={showConfirmDelete}
        setShowConfirmDelete={setShowConfirmDelete}
        setConfirmReset={setConfirmReset}
        setErrorMsg={setErrorMsg}
        setEditTenant={setEditTenant}
        pageTitle={pageTitle}
        moduleOptions={moduleOptions}
        selectedModuleIds={selectedModuleIds}
        setSelectedModuleIds={setSelectedModuleIds}
    />
);
};

export default CreateOrEditUserContainer;